import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LibOptionValue } from 'daisy-design-system-front';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { DropdownComponent } from '../../dropdown/dropdown.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { EnergyType } from '../../../../../swagger-gen/web-secured/models/energy-type';

@Component({
  selector: 'app-select-station-energy',
  standalone: true,
  imports: [CommonModule, FormsModule, ReactiveFormsModule, DropdownComponent, TranslateModule],
  templateUrl: './select-station-energy.component.html',
  styleUrls: ['./select-station-energy.component.scss']
})
export class SelectStationEnergyComponent implements OnInit {
  @Input() valueFormControl = new FormControl<EnergyType[] | null>(null);

  public stationEnergies: LibOptionValue<EnergyType>[] = [];

  constructor(private readonly translate: TranslateService) {}

  ngOnInit(): void {
    this.stationEnergies = Object.values(EnergyType).map(value => ({label: this.translate.instant(value), value: value}))
  }
}
